import {
  Component, OnInit, Input, OnDestroy,
  ChangeDetectorRef,
  EventEmitter, Output
} from '@angular/core';
import { IPackItem } from '@app/certificates/packs/packs';
import { TranslateService } from '@ngx-translate/core';
import { PackType } from '@app/certificates/manage/manage';
import { InfoService } from '@app/core/info/info.service';
import { Subject } from 'rxjs';
import { PackService } from '@app/certificates/packs/pack.service';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { profilePlanSelector } from '@app/profile/profile-remaining-count/profile-plan.reducer';
import { IProfilePlan } from '@app/profile/main/details';
import { SessionStorageService } from '@app/core/local-storage/local-storage.service';

@Component({
  selector: 'cloud-pack-items',
  templateUrl: './pack-items.component.html',
  styleUrls: ['./pack-items.component.scss'],
})
export class PackItemsComponent implements OnInit, OnDestroy {
  @Input() pack: IPackItem;
  @Output() onBuyBtnClicked = new EventEmitter<any>();

  hasActiveInfinitePlan = false;
  tiles = {};

  private unsubscribe$: Subject<void> = new Subject<void>();
  packs: any;
  constructor(
    private translateService: TranslateService,
    private info: InfoService,
    private packService: PackService,
    private sessionStorageService: SessionStorageService,
    private cd: ChangeDetectorRef,
    private store: Store<any>
  ) { }

  ngOnInit() {
    this.packs = this.sessionStorageService.getItem('packs')
    this.info.dismissAll();
    this.store
      .select(profilePlanSelector)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((profilePlan: IProfilePlan) => {
        if (profilePlan) {
          if (profilePlan.remainingCount === -1 && (new Date(profilePlan.packageEndDate).getTime() > new Date().getTime())) {
            this.hasActiveInfinitePlan = true;
          }
        }
      });
    for (const lang in this.pack.description) {
      this.tiles[lang] = [];
      for (const i of this.pack.description[lang].split(';')) {
        this.tiles[lang].push({ text: i, cols: 1, rows: 1 });
      }
    }
  }

  get buyPack() {
    this.cd.markForCheck();
    return this.translateService.instant('packsTexts.buy');
  }

  get packCount() {
    const cntTranslationCode = this.packService.getPackCountTranslationCode(this.pack.count);
    return this.translateService.instant(cntTranslationCode, { value: this.pack.count });
  }

  get validityText() {
    if (this.pack.validityPeriod > -1) {
      if (this.pack.validityPeriod === 1) {
        return '1 ' + this.translateService.instant('packsTexts.month');
      } else {
        return this.translateService.instant('packsTexts.months', { period: this.pack.validityPeriod });
      }
    } else {
      return this.translateService.instant('packsTexts.unlimited');
    }
  }

  get img() {
    return `/assets/images/packs/${this.pack.picture}`;
  }

  get lang() {
    return this.translateService.currentLang;
  }

  isInfinitePlan(type: PackType): boolean {
    return type === PackType.INFINITE;
  }

  /**
   * Диспачваме действие, с което съобщаваме своя избор на удостоверение.
   * Самото предвиждане по степера се случва в бащинския компонент (pack)
   * @param packId
   * @param certId
   */
  onOrderClick(packId: IPackItem['id']) {
    this.info.dismissAll();
    this.onBuyBtnClicked.emit({ packId });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
